import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/* =========================================================
   React Router keeps the scroll position across navigations,
   so arriving on a new page mid-scroll lands you mid-page.
   Mount this ONCE above <Routes> (next to AccountBackBar):

     import ScrollToTop from "./goourhub/component/ScrollToTop";
     ...
     <ScrollToTop />
     <Routes> ... </Routes>

   Every route change then starts at the top, app-wide.
   ========================================================= */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
